<template>
  <scoped>
    <VerticalNavigator
      :links="[{
        title: 'Create',
        routeName: 'sale_order_create'
      }]"
    >
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Sale Orders"
      />
      <h1>
        Sale Orders
      </h1>
      <div class="grid">
        <div class="list">
          <SaleOrderSelector v-model:value="selectedOrder" />
        </div>
        <div
          v-if="selectedOrder"
          class="summary"
        >
          <OrderSummary
            :key="selectedOrder.id"
            :orderID="selectedOrder.id"
          />
          <Button
            title="Edit"
            :image="require('@/images/edit_icon.png')"
            @click="orderRedirect()"
          />
        </div>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import SaleOrderSelector from "@/components/selectors/sale_order.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import OrderSummary from "@/components/summaries/order.vue"
  import router from "@/router"
  import {Order} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  const selectedOrder = ref<Order>(null)
  
  function orderRedirect() {
    router.push({
      name: "sale_order_edit",
      params: {
        orderID: selectedOrder.value.id
      }
    })
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-areas: "list summary";
    grid-template-columns: auto 1fr;
  
    .list {
      grid-area: list;
      margin: 0 1em 1em 0;
    }
  
    .summary {
      grid-area: summary;
    }
  }
</style>
